import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { SupplierProduct } from 'types/supplier';
import SupplierProductsList from './list/SupplierProductsList';
import SupplierProductForm from './form/SupplierProductForm';
import ConfirmDialog from 'components/confirm-dialog/ConfirmDialog';
import { countLabel, RecordToolbar } from 'components/record-shell/RecordList';
import { Supplier } from 'types/supplier';

interface SupplierProductsProps {
  supplier: Supplier;
  handleChangeAddProduct(product: SupplierProduct): void;
  handleDeleteProduct(product: SupplierProduct): void;
}

const SupplierProducts: React.FC<SupplierProductsProps> = ({
  supplier,
  handleDeleteProduct,
  handleChangeAddProduct,
}) => {
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<SupplierProduct | null>(null);
  const [productInfo, setProductInfo] = useState<SupplierProduct>({
    cost_price: 0,
    product_id: 0,
    product_name: '',
    supplier_id: supplier.id,
    id: 0,
    product_unit: '',
    sale_price_max: 0,
    sale_price_min: 0,
    product_manufacturer: '',
  });

  function handleChangeProductInfo<K extends keyof SupplierProduct>(index: K, value: SupplierProduct[K]) {
    setProductInfo(prev => ({ ...prev, [index]: value }));
  }

  function handleAddProduct(productInfo: SupplierProduct | null) {
    if (!productInfo) return;
    handleChangeAddProduct(productInfo);
    setAddDialogOpen(false);
    setProductInfo({
      cost_price: 0,
      product_id: 0,
      product_name: '',
      supplier_id: supplier.id,
      id: 0,
      product_unit: '',
      sale_price_max: 0,
      sale_price_min: 0,
      product_manufacturer: '',
    });
  }

  function onExited() {
    setAddDialogOpen(false);
    setProductInfo({
      cost_price: 0,
      product_id: 0,
      product_name: '',
      supplier_id: supplier.id,
      id: 0,
      product_unit: '',
      sale_price_max: 0,
      sale_price_min: 0,
      product_manufacturer: '',
    });
    setEditDialogOpen(false);
  }

  function handleEditProduct(product: SupplierProduct, index: number) {
    setEditDialogOpen(true);
    setProductInfo(product);
  }

  return (
    <Grid container size={12} spacing={2}>
      {confirmDialogOpen && (
        <ConfirmDialog
          confirmLabel="Excluir"
          destructive
          handleNoClick={() => setConfirmDialogOpen(null)}
          handleYesClick={() => {
            handleDeleteProduct(confirmDialogOpen);
            setConfirmDialogOpen(null);
          }}
          title="Tem certeza que deseja excluir este produto?"
        />
      )}
      <Grid size={12}>
        <RecordToolbar
          title={countLabel(supplier.products.length, 'produto', 'produtos', 'Nenhum produto')}
          addLabel="Adicionar produto"
          onAdd={() => setAddDialogOpen(true)}
        />
      </Grid>

      {supplier.products.length > 0 && (
        <Grid size={12}>
          <SupplierProductsList
            products={supplier.products}
            handleDeleteProduct={item => setConfirmDialogOpen(item)}
            handleEditProduct={handleEditProduct}
          />
        </Grid>
      )}

      {addDialogOpen && (
        <SupplierProductForm
          type="new"
          handleChangeProductInfo={handleChangeProductInfo}
          productInfo={productInfo}
          handleAddProduct={handleAddProduct}
          onExited={onExited}
        />
      )}

      {/* Formulário de Edição de Produto */}
      {!!productInfo.id && editDialogOpen && (
        <SupplierProductForm
          type="edit"
          handleChangeProductInfo={handleChangeProductInfo}
          productInfo={productInfo}
          handleAddProduct={handleAddProduct}
          onExited={onExited}
        />
      )}
    </Grid>
  );
};

export default SupplierProducts;
